// extracted by mini-css-extract-plugin
export default {"container":"ySj0O","arrow":"prBCU","page":"B32No","active":"_6ug45"};